module.exports = __webpack_public_path__ + "static/img/ER.ad949fa7.svg";